export default __webpack_public_path__ + "static/media/logo.857c4165.svg";